import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { Origin } from '@upstart/harmony/lib/constants';
import { sendData } from 'util/amplitude';
import {
  VehicleSelectedAction,
  Action,
  amplitudeEventsVehicleselection,
} from 'util/amplitudeEvents';
import SidebarContainer from '../SidebarContainer';
import VehicleSelection from './VehicleSelection';
import dealsActions from '../../redux/deals/actions';
import { HeaderNotice, HeaderNavigation } from '../../components/PencilEditor';
import { isEmbeddedInCommandCenter } from '../../util/commandCenter';

const sendAddVehicleAmplitudeEvent = (event, properties) => {
  const eventName = amplitudeEventsVehicleselection[event];
  if (eventName) {
    sendData(eventName, properties);
  }
};

function NewDeal({ actions, fetching, user }) {
  const onCarSelect = car => {
    actions.dealCreateRequest({
      car_id: car.id,
      user_id: user.id,
      origin: Origin.DESKING,
      lastOpenedInStore: new Date(),
      carSource: car.manuallyEnteredSource || '',
    });
    sendAddVehicleAmplitudeEvent(VehicleSelectedAction.FINISH, {
      carMake: car.make,
      carModel: car.model,
      carYear: car.year,
    });
  };
  useEffect(() => {
    if (!user) {
      return;
    }
    sendAddVehicleAmplitudeEvent(Action.START);
  }, []);

  if (!user) {
    return null;
  }

  const pageContent = (
    <div className="pencil-editor-container">
      {fetching ? (
        <Dimmer active inverted>
          <Loader inverted content="Loading" />
        </Dimmer>
      ) : (
        <div className="pencil-editor-left-column">
          <div className="pencil-editor-header">
            <HeaderNavigation />
            <HeaderNotice user={user} />
          </div>
          <VehicleSelection
            onSelect={onCarSelect}
            sendAddVehicleAmplitudeEvent={sendAddVehicleAmplitudeEvent}
          />
        </div>
      )}
    </div>
  );

  return isEmbeddedInCommandCenter() ? (
    pageContent
  ) : (
    <SidebarContainer title="Desking">{pageContent}</SidebarContainer>
  );
}

NewDeal.propTypes = {
  actions: PropTypes.object,
  fetching: PropTypes.bool,
  user: PropTypes.object,
};

const mapStateToProps = state => ({
  user: state.user.currentUser,
  fetching: state.deals.fetching,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(dealsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewDeal);
